
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import DefaultAvatar from "./DefaultAvatar";

interface PhotoAvatarProps {
  photo: string;
  index: number;
  isMain: boolean;
  onSetMain: () => void;
  onRemove: () => void;
}

const PhotoAvatar = ({ photo, index, isMain, onSetMain, onRemove }: PhotoAvatarProps) => {
  const isPlaceholder = photo === "/placeholder.svg";

  return (
    <div className="flex flex-col items-center space-y-2 flex-shrink-0">
      {/* Avatar Container with Main Photo Border */}
      <div className={`relative ${isMain ? 'ring-2 ring-neon-red ring-offset-2 ring-offset-carbon' : ''} rounded-full`}>
        <Avatar className="w-16 h-16">
          {isPlaceholder ? (
            <AvatarFallback className="bg-carbon border border-ice-white/20">
              <DefaultAvatar size="sm" className="w-8 h-8" />
            </AvatarFallback>
          ) : (
            <AvatarImage 
              src={photo} 
              alt={`Profile photo ${index + 1}`}
              className="object-cover"
            />
          )}
        </Avatar>
        
        {/* Remove Button */}
        <Button
          variant="destructive"
          size="icon"
          className="absolute -top-1 -right-1 w-5 h-5 rounded-full shadow-lg opacity-80 hover:opacity-100"
          onClick={onRemove}
        >
          <X className="w-3 h-3" />
        </Button>
      </div>
      
      {/* Toggle Button */}
      <Button
        variant={isMain ? "default" : "outline"}
        size="sm"
        className={`text-xs px-2 py-1 h-6 ${
          isMain 
            ? 'bg-neon-red hover:bg-neon-red/80 text-ice-white' 
            : 'border-ice-white/20 text-ice-white/70 hover:text-ice-white hover:border-ice-white/40'
        }`}
        onClick={onSetMain}
      >
        {isMain ? 'MAIN' : 'SET MAIN'}
      </Button>
    </div>
  );
};

export default PhotoAvatar;
